module.exports = __webpack_public_path__ + "static/media/logo.2619fd2a.svg";